import { defineComponent as _defineComponent } from 'vue'
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import { FieldVariable } from '@/views/Automation/CampaignCreatorV2/store/AbVariables';
import { InternalABVariable } from '@/views/Automation/CampaignCreatorV2/store/Types';
import { CardLayer } from '@/views/Automation/CampaignCreatorV2/types';
import Treeselect from '@riophae/vue-treeselect';
import { onBeforeMount, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CcBudget.ts',
  props: {
    title: null,
    budget: null,
    removable: { type: Boolean },
    errros: null,
    field: null
  },
  emits: ["update", "rename", "remove"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update', value: { value: string; budget_type: string }): void;
  (e: 'rename', value: { budget: any; newName: string }): void;
  (e: 'remove'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  title: string;
  budget: InternalABVariable<number>;
  removable?: boolean;
  errros?: string[];
  field?: FieldVariable<any, any>;
};





const budget_type = ref('');
const budget_value = ref('');

onBeforeMount(() => {
  if (props.budget) {
    budget_type.value = props.budget.field;
    budget_value.value = props.budget.value.toString();
  }
});

function updateBudget(value: { id: string } | string, key: string) {
  if (key === 'value' && typeof value === 'string') {
    budget_value.value = value;
  } else if (typeof value === 'object') {
    budget_type.value = value.id;
  }

  emits('update', { budget_type: budget_type.value, value: budget_value.value });
}

function handleRename(value: string) {
  emits('rename', { budget: props.budget, newName: value });
}

return { __sfc: true,emits, props, budget_type, budget_value, updateBudget, handleRename, CcCardItem, CcError, CardLayer, Treeselect }
}

})